import { render } from "./saveSellOutMould.vue?vue&type=template&id=684a94d9"
import script from "./saveSellOutMould.vue?vue&type=script&lang=js"
export * from "./saveSellOutMould.vue?vue&type=script&lang=js"

import "./saveSellOutMould.vue?vue&type=style&index=0&id=684a94d9&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__